import React, {useEffect, useRef, useState} from 'react'
import './styles.css'
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import CheckIcon from "../../../../../../../../assets/icons/CheckIcon";
import XIcon from "../../../../../../../../assets/icons/XIcon";
import EditButton from "../../../../../../../../components-new/buttons/actions/EditButton";
import DeleteButton from "../../../../../../../../components-new/buttons/actions/DeleteButton";
import LinkIcon from "../../../../../../../../assets/icons/LinkIcon";
import colors from "../../../../../../../../utils/Colors";
import Popup from "../../../../../../../../components-new/ui/Popup";
import Input from "../../../../../../../../components-new/form/Input";

const NodeEditorButton = ({
                      text = '',
                      link = '',
                      defaultEditable = false,
                      onSave,
                      onLinkSave,
                      onDelete,
                      onCancelEdit,
                      readonly = false,
                      onClick = null,
                      ref,
                      style = {},
                      buttonVariants = 'default',
                      popupDirection = 'bottom'
                  }) => {
    const [editable, setEditable] = useState(defaultEditable);
    const [value, setValue] = useState(text);
    const [linkValue,setLinkValue] = useState(link);
    const [linkPopupIsOpen, setLinkPopupIsOpen] = useState(false);

    let valueBackup = text;
    const textareaRef = useRef(null);
    const linkInputRef = useRef(null);

    const ignoreBlurRef = useRef(false);

    useEffect(() => {
        setTimeout(() => {
            if (editable && textareaRef.current) {
                const el = textareaRef.current;
                el.focus();

                const length = el.value.length;
                el.setSelectionRange(length, length);
            }
        },500)
    }, [editable]);

    useEffect(() => {
        const el = textareaRef.current;
        if (el) {
            el.style.height = 'auto';
            el.style.height = el.scrollHeight + 'px';
        }
    }, [value, editable]);

    useEffect(() => {
        setValue(text);
    }, [text]);

    useEffect(() => {
        if(linkPopupIsOpen) {
            if(linkInputRef.current){
                linkInputRef.current.focus();
            }
        }else{
            setLinkValue(link);
        }
    },[linkPopupIsOpen])

    const handleActionKeyDowns = e => {
        if(e.key === 'Escape'){
            e.stopPropagation();
            setLinkPopupIsOpen(false);
        }
        if(e.key === 'Enter'){
            e.stopPropagation();
            onLinkSave(linkValue);
            setLinkPopupIsOpen(false);
        }
    }

    return (
        <div
            className={"node-editor-button-container" + (onClick ? ' hoverable' : '')}
            onClick={onClick}
            ref={ref}
            style={style}
        >
            {
                readonly ?
                    <span>{text}</span>
                    :
                    <textarea
                        ref={textareaRef}
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        disabled={!editable}
                        style={{
                            overflow: 'hidden',
                            resize: 'none',
                        }}
                        rows={1}
                        onBlur={()=>{
                            if(ignoreBlurRef.current)return
                            onSave(value)
                            setEditable(false)
                        }}
                        onKeyDown={(e) => {
                            if (editable && e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                onSave(value);
                                setEditable(false);
                            }
                            if (e.key === 'Escape') {
                                e.preventDefault();
                                setEditable(false);
                                setValue(valueBackup);
                                if (onCancelEdit && typeof onCancelEdit === 'function') {
                                    onCancelEdit();
                                }
                            }
                        }}
                    />
            }


            {
                !readonly &&
                <div className="node-editor-button-actions">

                    <Popup
                        isOpen={linkPopupIsOpen}
                        trigger={
                            <SilverButton
                                width={'32px'}
                                height={'32px'}
                                onClick={() => {
                                    setLinkPopupIsOpen(true);
                                }}
                                variant={buttonVariants}
                            >
                                <LinkIcon width={18} height={18} style={{color: link ? colors.blueDark : colors.silver}} stroke="currentColor"/>
                            </SilverButton>
                        }
                        panelInnerStyle={{padding:'2px',display:'flex',alignItems: 'center',gap:'4px'}}
                        panelStyle={{padding:'2px',borderRadius:'10px'}}
                        onOpenChange={setLinkPopupIsOpen}
                        panelAlign={{horizontal: '', vertical: 'bottom'}}
                        direction={popupDirection}
                    >
                        <Input
                            value={linkValue}
                            ref={linkInputRef}
                            onChange={e => setLinkValue(e.target.value)}
                            style={{width:'200px',height:'28px'}}
                            onKeyDown={handleActionKeyDowns}
                        />
                        <SilverButton
                            width={'28px'}
                            height={'28px'}
                            onClick={() => {
                                onLinkSave(linkValue);
                                setLinkPopupIsOpen(false);
                            }}
                            variant={buttonVariants}
                            disabled={link === linkValue}
                        >
                            <CheckIcon width="16" height="16" className="save-icon"/>
                        </SilverButton>
                    </Popup>

                    {editable ? (
                        <SilverButton
                            width={'32px'}
                            height={'32px'}
                            onMouseDown={()=>{
                                ignoreBlurRef.current = true;
                            }}
                            onClick={() => {
                                setEditable(false);
                                setValue(valueBackup);
                                if (onCancelEdit && typeof onCancelEdit === 'function') {
                                    onCancelEdit();
                                }
                                ignoreBlurRef.current = false;
                            }}
                            variant={buttonVariants}
                        >
                            <XIcon width={18} height={18} style={{color: colors.blueDark}} stroke="currentColor"/>
                        </SilverButton>
                    ) : (
                        <DeleteButton onClick={onDelete} variant={buttonVariants}/>
                    )}

                    {editable ? (
                        <SilverButton
                            width={'32px'}
                            height={'32px'}
                            onClick={() => {
                                onSave(value);
                                setEditable(false);
                            }}
                            variant={buttonVariants}
                        >
                            <CheckIcon width="18" height="18" className="save-icon"/>
                        </SilverButton>
                    ) : (
                        <EditButton
                            onClick={() => {
                                setEditable(true);
                                valueBackup = value;
                            }}
                            variant={buttonVariants}
                        />
                    )}
                </div>
            }

        </div>
    );
};

export default NodeEditorButton;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/NodeEditor/components/NodeEditorButton/index.jsx